import React from "react";
import {
  CashIcon,
  UserActive,
  UserPending,
  UserCalendar,
  CreditCardPayIcon,
  SettingsIcon,
} from "components/Icons";
import { Roles } from "common/constants";

export const RoutesLevel2 = [
  {
    label: "Upload",
    icon: <CreditCardPayIcon width="100%" height="100%" />,
    link: "/payments",
    roles: [Roles.BusinessOwner],
    isActive: true,
  },
  {
    label: "Payment Processing Requests",
    icon: <CashIcon width="100%" height="100%" />,
    link: "/payment-processing-requests",
    roles: [Roles.PaymentOps],
    isActive: true,
  },
  {
    label: "Payment Summary",
    icon: <CashIcon width="100%" height="100%" />,
    link: "/payment-summary",
    roles: [Roles.BusinessOwner],
    isActive: true,
  },
  {
    label: "Approval Dashboard",
    icon: <CashIcon width="100%" height="100%" />,
    link: "/approval-dashboard",
    roles: [Roles.BusinessApprover, Roles.BUApprover],
    isActive: true,
  },
  {
    label: "Active Enterprise Users",
    icon: <UserActive width="100%" height="100%" />,
    link: "/enterprise-users",
    roles: [Roles.PaymentOps, Roles.BusinessAdmin],
    isActive: true,
  },
  {
    label: "Activation Pending Enterprise Users",
    icon: <UserPending width="100%" height="100%" />,
    link: "/activation-pending-enterprise-users",
    roles: [Roles.BusinessAdmin],
    isActive: true,
  },
  {
    label: "Audit Activity",
    icon: <UserCalendar width="100%" height="100%" />,
    link: "/audit-activity",
    roles: [Roles.PaymentOps, Roles.BUChecker, Roles.BUMaker, Roles.BUApprover],
    isActive: true,
  },
  {
    label: "File Processing Settings",
    icon: <SettingsIcon width="100%" height="100%" />,
    link: "/file-processing-settings",
    roles: [Roles.BusinessAdmin],
    isActive: true,
  },
];
